<template>
  <ion-card>
    <ion-card-content>
      <p>
        Are you sure you want to remove {{ user.email }} from bridge {{ serialNumber }}? They will no longer be able to
        access the companion app and webviewer.
      </p>
    </ion-card-content>
    <ion-card-footer>
      <ion-row>
        <ion-col size-md="6">
          <ion-button
            expand="full"
            @click="close"
          >
            Cancel
          </ion-button>
        </ion-col>
        <ion-col size-md="6">
          <ion-button
            expand="full"
            :disabled="busy"
            color="warning"
            @click="deleteUser"
          >
            <ion-spinner v-if="busy" />
            Remove user
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { modalController } from '@modus/ionic-vue'
import store from '../../state'

export default {
  props: {
    serialNumber: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    busy: false,
  }),
  methods: {
    async deleteUser () {
      this.busy = true
      try {
        await store.dispatch('deleteUser', {
          serialNumber: this.serialNumber,
          uuid: this.user.uuid,
        })
        await store.dispatch('fetchUsers', { serialNumber: this.serialNumber })
      } finally {
        this.close()
      }
    },
    close(){
      return modalController.dismiss()
    }
  },
}
</script>

<style scoped>
ion-card {
  margin: 0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background: none;
}
</style>
